<template>
  <div class="pa-6 mt-0" style="width: 100%">
    <div class="mb-6">
      <div class="component-title">Phúc khảo</div>
    </div>

    <v-card outlined class="pa-6 mb-6 elevation-0">
      <MarkReviewFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView />
    </div>
    <v-card v-else outlined class="elevation-0">
      <MarkReviewTable
        ref="assignTable"
        :query="query"
        :subjects="subjects"
        :rooms="rooms"
        :type="type"
        :grade="grade"
      />
    </v-card>
  </div>
</template>
<script>
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import MarkReviewFilter from '@/modules/exam/MarkReviewFilter.vue'
import MarkReviewTable from '@/modules/exam/MarkReviewTable.vue'

export default {
  components: {
    StudentBlankView,
    MarkReviewFilter,
    MarkReviewTable
  },
  data() {
    return {
      action: {
        state: 'select'
      },
      subjects: [],
      rooms: [],
      query: {},
      type: '',
      grade: '',
      dialog: false
    }
  },
  computed: {},
  methods: {
    onFilterChanged(params, subjects, rooms, type, grade) {
      this.action.state = 'filtered'
      this.query = params
      this.subjects = subjects
      this.rooms = rooms
      this.type = type
      this.grade = grade
    },
    update(item) {
      this.item = item
      this.updateDialog = true
    },
    remove(item) {
      this.item = item
      this.deleteDialog = true
    },
    openCreate() {
      this.dialog = true
    },
    refresh() {
      this.$refs.assignTable.refresh()
    },
    openConfirm() {
      this.confirmDialog = true
    },
    close() {
      this.dialog = false
    },
    closeUpdate() {
      this.refresh()
      this.updateDialog = false
    },
    closeDelete() {
      this.deleteDialog = false
    },
    closeConfirm() {
      this.confirmDialog = false
    }
  }
}
</script>

<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
